<template>
  <SmartHrLocalList module-type="CONTRACT" title="合同管理" group-name="员工关系"/>
</template>
<script>
import SmartHrLocalList from './SmartHrLocalList'
export default {
  name: 'SmartHrContract',
  components: { SmartHrLocalList }
}
</script>



// WEBPACK FOOTER //
// SmartHrContract.vue?fe9c8334